// extracted by mini-css-extract-plugin
module.exports = {"mainTableTop":"Table_mainTableTop__2tQd8","mainTableBottom":"Table_mainTableBottom__1HzIb","typeText":"Table_typeText__3Y-zQ"};